import React, { Component } from 'react';
import { connect } from 'react-redux';
import card from '../../images/icons/ico_cc_def.png';
import cardVisa from '../../images/icons/ico_cc_visa.png';
import {withTranslation} from 'react-i18next'
import { PAYMENT_GATEWAY, CARD_CAN_BE_CHARGED, DEMO, CARD_DEMO, CMSPath, DEV_IP } from '../../../config/constant';
import Loader from '../../UI/loader';
import clientConfigApi from '../../../config/config';
import {setCardStatusPopupProps, setCheckinCurrentPageName} from '../../action/autoCheckin';
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import $ from "jquery";

window.elavonCallbak = (response, status, confirmationNumber, userInfo) => {
    console.log("Callback from elavon", status, response);
    $(".lightbox-iframe-container").attr("style", "")

    let self = window.cardComponent;
        try {

            self.setState({showLightBoxPage: false})

            if(status == "approved"){

                self.props.showLoader(true);
                clientConfigApi.post("/mobileCheckIn/cardValidation", {
                    "header": {
                      "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                      "actionKey":"cardUpdate"
                    },
                    "payload": {
                        "confirmationNumber": confirmationNumber,
                        "cardDigits": response.ssl_card_number.slice(12,17),//this.state.cardNumber.slice(-this.props.cardChecksData.cardNumberOfDigits,this.state.cardNumber.length),
                        "firstNameCard": response.ssl_first_name,
                        "lastNameCard": response.ssl_last_name,
                        "cardCheckId":response.ssl_partner_app_id,
                        "transactionType": "ccverify",
                        "reservationNumber":response.ssl_transaction_reference_number, // 383244512326
                        "vaultedCardId":response.ssl_token,
                        "cardTypeCode": response.ssl_card_short_description,
                        "expiryDate":response.ssl_exp_date
                    }
                  })
                  .then((res) => {
                    self.setState({cardVerified: true});
                    self.props.setcardVerified(true, response.ssl_token);
                    self.props.showFailScreen(false);
                    self.props.showLoader(false);
                    self.props.setCardStatusPopupProps({
                        cardStatus: true,
                        statusTitle: 'Success',
                        statusMessage1: 'Card verified successfully',
                        statusMessage2: 'Please proceed to next steps'
                    })
                    self.props.showCardVerified(userInfo)
                    localStorage.setItem("cardVerfied", true)
                    console.log("ssl_token", response.ssl_token, response)
                  })
                  .catch((err) => {
                    self.props.showFailScreen(true, "Unable to update card in the reservation. Please contact Front Desk");
                    self.props.showLoader(false);
                    if(window.FirebasePlugin){
                        window.FirebasePlugin.logError("Unable to update card in the reservation.", err)
                    }
                  })
            }

            if(status == "declined"){
                self.props.showFailScreen(true, response.ssl_result_message);
                self.props.showLoader(false);
                if(window.FirebasePlugin){
                    window.FirebasePlugin.logError("Card validation declined elavon: ", response.ssl_result_message )
                }
            }

            if(status == "error"){
                self.props.showFailScreen(true, response);
                self.props.showLoader(false);
                if(window.FirebasePlugin){
                    window.FirebasePlugin.logError("Error at card validation elavon: ", response )
                }
            }

            if(status == "cancelled"){
                self.props.showFailScreen(true, "Card validation cancelled");
                self.props.showLoader(false);
            }

            // Send Analytics
            let failedReason = status != "approved" ? status == "error" ? response : status == "declined" ? response.ssl_result_message : "Card validation cancelled" : ""
            let label = {
                            "cardCode": status == "approved" ? response.ssl_card_short_description : "",
                            "dateTime": new Date,
                            "errorMessage": status != "approved" ? failedReason : "",
                            "appVersion": `${self.props.installedAppVersion}(${self.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": self.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }
            self.props.sendAnalytics(
                null, 
                self.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                status == "approved" ? "CREDIT CARD DETAILS - SUCCESS" : "CREDIT CARD DETAILS - FAILED", 
                label, 
                0, 
                false
            );
            //

        }catch (e) {
            console.log("error while calling callback from elavon", e);
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("error while calling callback from elavon" + e)
              }
        }
    };

class AddCard extends Component{

    constructor(props){
        super(props)
        this.state = {
            showLoader: false,
            cardNumber: "",
            expiryDate: "",
            sessionToken: localStorage.getItem("GuestJourneySessionToken"),
            cvv: "",
            address: "",
            zip: "",
            firstName: "",
            lastName: "",
            formattedCardNumber: "",
            cardVerified: false
        }

        window.cardComponent = this
        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        window.addEventListener("message", this.handleMessageEvent);
    }

    handleMessageEvent(e) {
        try {
            if (e.data && JSON.parse(e.data) && JSON.parse(e.data).status) {
                window.elavonCallbak(JSON.parse(e.data).response, JSON.parse(e.data).status, this.props.confirmationNumber, {firstName: this.state.firstName, lastName: this.state.lastName});
            }   
        } catch (error) {
            console.log("error handling message eventlistener")
        }
    }

    confirmCardWithPMS = () => {

        if(!this.state.firstName){
            this.props.popupOpenClose(true, "Please enter your first name");
            return;
        }
        if(!this.state.lastName){
            this.props.popupOpenClose(true, "Please enter your last name");
            return;
        }

        if(!this.state.address || this.state.address == ""){
            this.props.popupOpenClose(true, "Please enter your address");
            return;
        }

        if(!this.state.zip || this.state.zip == ""){
            this.props.popupOpenClose(true, "Please enter your postal code");
            return;
        }

        if(!(/^[a-zA-Z0-9, .]+$/.test(this.state.address))){
            this.props.popupOpenClose(true, "Please note that only English letters and numbers are accepted for the address")
            return;
        }

        this.props.setCheckInAddress({...this.props.checkInAddress, addressLine1: this.state.address, postalCode: this.state.zip})

        if(CARD_DEMO){
            this.props.showLoader(true);
            setTimeout(() => {
                this.props.showLoader(false);
                this.setState({cardVerified: true})
                this.props.setCardStatusPopupProps({
                    cardStatus: true,
                    statusTitle: 'Success',
                    statusMessage1: 'Card verified successfully',
                    statusMessage2: 'Please proceed to next steps'
                })
                this.props.showCardVerified({firstName: this.state.firstName, lastName: this.state.lastName})
                localStorage.setItem('cardVerfied', true)

                let label = {
                    "dateTime": new Date,
                    "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                    "Room": localStorage.getItem("room") || "",
                    "sourceApp": "guestJourneyApp",
                    "layoutTab": this.props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }
                this.props.sendAnalytics(
                    null, 
                    this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                    "CREDIT CARD DETAILS - SUCCESS", 
                    label, 
                    0, 
                    false
                );
                
            }, 1500)
            return;
        }

        // this.props.showLoader(true);
        this.setState({showLoader: true})

        clientConfigApi.post("/mobileCheckIn/cardValidation", {
            "header": {
              "sessionToken": this.state.sessionToken,
              "actionKey":"register"
            },
            "payload": {
                "confirmationNumber": this.props.confirmationNumber,
                "cardDigits": "",//this.state.cardNumber.slice(-this.props.cardChecksData.cardNumberOfDigits,this.state.cardNumber.length),
                "firstNameCard": this.state.firstName,
                "lastNameCard": this.state.lastName,
                "transactionType": "ccverify"
            }
          }).then(response => {
                // this.setState({showLoader: false})
                if(response.data.payload.merchantId && response.data.payload.tokenStr){
                    // this.pay(response.data.payload.merchantId, response.data.payload.tokenStr);
                    this.setState({showLightBoxPage: true, paymentToken: response.data.payload.tokenStr, merchantId: response.data.payload.merchantId})
                }
                else{
                    this.setState({showLoader: false});
                    this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
                    if(window.FirebasePlugin){
                        window.FirebasePlugin.logError("Card validation api failed CMS: ", response.data.header.status.msg )
                    }
                    // Send Analytics
                    let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                    let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
                                    "dateTime": new Date,
                                    "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                    this.props.sendAnalytics(
                        null, 
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        "CREDIT CARD DETAILS - FAILED", 
                        label, 
                        0, 
                        false
                    );
                    //
                }

          }).catch(response => {
            this.setState({showLoader: false})
                this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
                if(window.FirebasePlugin){
                    window.FirebasePlugin.logError("Card validation api failed CMS: ", response.data.header.status.msg )
                }
                // Send Analytics
                let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
                                "dateTime": new Date,
                                "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                            }
                this.props.sendAnalytics(
                        null, 
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        "CREDIT CARD DETAILS - FAILED", 
                        label, 
                        0, 
                        false
                    );
                //
          });
    }


    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessageEvent);
    }

    componentDidMount() {

        this.setState({
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            address: this.props.checkInAddress.addressLine1,
            zip: this.props.checkInAddress.postalCode
        })
        this.props.setCheckinCurrentPageName("CREDIT CARD DETAILS")

    }

    render(){
        const {t} = this.props
        return(
            <div className='lightbox-iframe-container'>
                {this.state.showLightBoxPage 
                ? <iframe frameborder="0" onLoad={() => {
                    $(".lightbox-container").attr("style", "width: 100%; height: 100%")
                    $(".lightbox-iframe-container").attr("style", "position: absolute; top: 0; left: 0; width: 100vw; height: 100vh; background: #fff")
                    this.setState({showLoader: false})
                }} style={{width: 0, height: 0}} className='lightbox-container' src={ !DEMO ? `https://guest-journey.s3.amazonaws.com/static/lightbox.html?token=${this.state.paymentToken}&address=${this.state.address}&zip=${this.state.zip}` : `http://${DEV_IP}:8080/cmsData/elavon/lightbox.html?token=${this.state.paymentToken}&address=${this.state.address}&zip=${this.state.zip}` }></iframe> 
                : <div>
                    <header className="inner-pages w-footer subpages">
                    <a className="button-back" onClick = {this.props.backBtn}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                <div class="widget-header widget-header-checkin-inner card-validation">
                    { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                        </div>
                    }

                    {
                        process.env.REACT_APP_NEWER_DESIGN=="true" 
                        ?
                        <>
                            <div class="widget-header-title">{t("check_in.verify_card_heading")}</div>
                              <div class="widget-header-subtitle">{t("check_in.verify_card_subheading")}</div>
                        </>
                        :
                        <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div> 

                    }
                     </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2>{t('check_in.booking_details')}</h2>
                        </div>
                        {  !(localStorage.getItem('cardVerfied') == 'true') ?
                            <div className="form-window">
                                <div className="form-window-heading">
                                {t('check_in.card_details')}
                                </div>
                                <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                    <p>{ CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : "Please enter your card details."} </p>
                                    <div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="firstName">First Name <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="firstName" 
                                                autoComplete='given-name' 
                                                onChange={(e) => this.setState({firstName: e.target.value})} 
                                                value={this.state.firstName}
                                                type="text" 
                                                placeholder="First Name" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="lastName">Last Name <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="lastName" 
                                                autoComplete='family-name' 
                                                onChange={(e) => this.setState({lastName: e.target.value})} 
                                                value={this.state.lastName}
                                                type="text" 
                                                placeholder="Last Name" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="address">Address <span style={{color:"red"}}>*</span></label> 
                                            <input 
                                                name="address" 
                                                autoComplete='address-line1'
                                                onChange={(e) => this.setState({address: e.target.value})} 
                                                value={this.state.address}
                                                placeholder="Street Name and Number"
                                                type="text" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="postalCode">Postal Code <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="postalCode"
                                                autoComplete='postal-code' 
                                                onChange={(e) => this.setState({zip: e.target.value})} 
                                                value={this.state.zip}
                                                placeholder="Postal Code"
                                                />
                                        </div>
                                    </div>
                                    
                                    <div className="form-controls">
                                        <button disabled={this.state.cardVerified} className="primary w-100" onClick = {this.confirmCardWithPMS}>Verify Card</button>
                                    </div>
                                    {DEMO && <input class="card-skip" onClick={() => this.props.next({firstName: this.state.firstName, lastName: this.state.lastName})} type="submit" value="Skip" style={{marginTop: '1rem', color: "#000", backgroundColor: "#fff"}}/>}
                                </div>
                            </div>
                        :
                            <div class="form-window">
                                <div class="form-window-heading">
                                    Card verified
                                </div>
                                <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                    <div class="form-row margin-bottom-1">
                                    <p>Your card was successfully verified.</p> {/* **** **** **** 4242  */}
                                        <p>Tap on NEXT to proceed</p> 
                                    </div>
                                    <div class="form-controls">
                                        {/* <button class="secondary w-100 margin-bottom-1">Change card</button>  */}
                                        <button className="primary w-100" onClick = {() => this.props.next({firstName: this.state.firstName, lastName: this.state.lastName})}>{t('check_in.next')}</button>
                                    </div>
                                </div>
                            </div>
                        }    
                    </div>
                </section>
            </div>}
            { this.state.showLoader && <Loader close={() => this.setState({showLoader: false})} displayMsg="Verifying data..." />}
        </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        cardChecksData: state.store2.cardChecksData,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        checkInAddress : state.store2.checkInAddress
    }
}

export default connect(mapStateToProps,{
    setCardStatusPopupProps,
    popupOpenClose,
    sendAnalytics,
    setCheckInAddress,
    setCheckinCurrentPageName
   })(withTranslation('translations')(AddCard));